/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InfoIcon from 'assets/icons/icon-info.svg';
import './CheckMark.scss';

const CheckMark = ({
  type, id, name, label, isDisabled, hasContainer, onCheckMarkChange,
  defaultValue, useLabel, child,
  withInfo, onWithInfoClick,
  // isChecked,
}) => {
  const val = useLabel ? label : id;
  const lowerCase = (str) => {
    if (!str) return null;
    return str.toLowerCase();
  };
  const checked = type === 'radio' ? lowerCase(defaultValue) === lowerCase(val) : defaultValue.indexOf(id) > -1;

  const classes = classNames({
    'nw-checkmark': true,
    'nw-checkmark--has-label': label,
    'nw-checkmark--disabled': isDisabled,
    'nw-checkmark--has-container': hasContainer,
    'nw-checkmark--has-child': child,
    'nw-checkmark--has-child-checked': checked && child,
    'nw-checkmark--with-info': withInfo,
  });

  return (
    <div className={classes}>
      <label
        htmlFor={id}
      >
        <input
          id={id}
          type={type}
          name={name}
          className="nw-checkmark__input" // defaultValue === id
          checked={checked}
          disabled={isDisabled}
          value={val}
          onChange={onCheckMarkChange}
        />
        <span className="nw-checkmark__container">
          <span className="nw-checkmark__switcher" />
          {label
            && <span className="nw-checkmark__label">{label}</span>
          }
          <span className="spacer" />
          {withInfo && (
          <img
            src={InfoIcon}
            alt="More info"
            onClick={(e) => {
              e.preventDefault();
              onWithInfoClick(id);
            }}
          />
          )}
        </span>
        {checked ? child : null}
      </label>
    </div>
  );
};

CheckMark.propTypes = {
  /** checkmark type */
  type: PropTypes.oneOf(['radio', 'checkbox']),
  /** checkmark id */
  id: PropTypes.string,
  /** checkmark name */
  name: PropTypes.string,
  /** checkmark label */
  label: PropTypes.node,
  // /** is checkmark checked */
  // isChecked: PropTypes.bool,
  /** is checkmark disabled */
  isDisabled: PropTypes.bool,
  /** has container */
  hasContainer: PropTypes.bool,
  /** on checkmark change */
  onCheckMarkChange: PropTypes.func,
  /** use label to save */
  useLabel: PropTypes.bool,
  /** with information icon */
  withInfo: PropTypes.bool,
  /** with info event */
  onWithInfoClick: PropTypes.func,
};

CheckMark.defaultProps = {
  type: 'radio',
  id: '1',
  name: 'name',
  label: null,
  // isChecked: null,
  isDisabled: false,
  hasContainer: false,
  onCheckMarkChange: () => {},
  useLabel: false,
  withInfo: false,
  onWithInfoClick: () => {},
};

export default CheckMark;
